import { Box, Grid, Paper ,Typography} from "@mui/material";

const PyR = ({ pregunta }) => {
    console.log(pregunta)
    return (
      <Paper
        elevation={4}
        square={true}
        className="animate__animated animate__fadeIn"
      >
        <Box p={3}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Box mt={2}>
                <Typography variant="subtitle2" fontWeight="bold">
                  P: {pregunta?.pregunta}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box mt={2}>
            <Typography variant="body2">
                R: {pregunta?.respuesta}
                </Typography>
          </Box>
        </Box>
      </Paper>
    );
  };
  export default PyR